import Cesium from 'cesium';

import defined from '~app/core/defined';

class Location {

  constructor(coordinates, geocodedName) {
    [this.lon, this.lat, this.height = 0.0] = coordinates;
    this.geocodedName = geocodedName;
  }

  coordinates() {
    return [this.lon, this.lat];
  }

  height() {
    return this.height;
  }

  degreeCoordinates() {
    return this.coordinates().map(radians => radians * (180.0 / Math.PI));
  }

  cartesian3(ellipsoid) {
    return new Cesium.Cartesian3.fromRadians(this.lon, this.lat, this.height, ellipsoid);
  }

  cartographic() {
    return new Cesium.Cartographic(this.lon, this.lat, this.height);
  }

  get displayName() {
    if (this.geocodedName) {
      return this.geocodedName;
    }
    return this.getCoordinateString();
  }

  getCoordinateString(precision = 1) {
    const degrees = this.degreeCoordinates();

    let lat = degrees[1];
    let latModifier = "N";
    if (lat < 0.0) {
      lat = -lat;
      latModifier = "S";
    }

    let lon = degrees[0];
    let lonModifier = "E";
    if (lon < 0.0) {
      lon = -lon;
      lonModifier = "W";
    }

    return `(${lat.toFixed(precision)}° ${latModifier}, \
${lon.toFixed(precision)}° ${lonModifier})`;
  }

  toString() {
    if (this.geocodedName) {
      return `${this.geocodedName}: ${this.getCoordinateString(3)}`;
    }
    return this.getCoordinateString(3);
  }

  equals(other) {
    if (this === other) {
      return true;
    }
    if (!defined(other.lat) || !defined(other.lon)) {
      return false;
    }
    return (this.lat === other.lat &&
            this.lon === other.lon);
  }
}

export default Location;



// WEBPACK FOOTER //
// ./src/core/location.js